export default __webpack_public_path__ + "static/media/slide4.9faf926a.jpg";